interface useSwipeUpNavigationProps {
  onSwipeUp: () => void;
}

export function useSwipeUpNavigation({ onSwipeUp }: useSwipeUpNavigationProps) {
  let touchStartY = 0;
  let touchEndY = 0;

  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartY = e.touches[0].clientY;
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    touchEndY = e.changedTouches[0].clientY;
    const swipeDistance = touchStartY - touchEndY;
    
    if (swipeDistance > 100) {
      onSwipeUp();
    }
  };

  return { handleTouchStart, handleTouchEnd };
};